import React, {useState, useEffect, useContext} from "react"
import {Button} from "react-bootstrap"
import {useLocation, useSearchParams} from "react-router-dom"
import useSWR from "swr"

import background from "../static/img/login-bkrd.jpg"
import IHarborLogoBlack from "../static/img/iharbor-logo-black.svg"
import IHarborLogoWhite from "../static/img/iharbor-logo-white.svg"
import OarsLogo from "../static/img/oars-logo.svg"
import OarsLogoBlk from "../static/img/oars-logo-black.svg"

import RefContext from "../utilities/RefContext"
import ToastMessage from "../utilities/ToastMessage"
import VersionCheck from "./VersionCheck"

const fetchData = async () => {
    // const [resp1] = await Promise.all([wrappedGet("/system-alert")])
    // return {
    //     data: resp1.data.response,
    // }
}

export function Login(props) {
    const {state} = useLocation()

    const [error, _setError] = useState(false)
    const [errorMessage, _setErrorMessage] = useState()
    const {dispatch} = useContext(RefContext)

    const {data} = useSWR("SystemAlert", fetchData, {fallbackData: {}, refreshInterval: 1000 * 60 * 5})
    const alertMessage = data.data || {}
    const [searchParams] = useSearchParams()

    useEffect(() => {
        document.title = "Login"
        if (state?.isTimeout) {
            document.documentElement.setAttribute("data-bs-theme", "light")
            dispatch("showToast", {show: true, variant: "warning", text: "Session timed out. Please log back in."})
        }

        // OIDC error from callback redirect
        const oidcError = searchParams.get("error")
        if (oidcError) {
            const errorMessages = {
                oidc_init_failed: "Could not start UMMS sign-in. Please try again.",
                oidc_callback_failed: "Sign-in with UMMS failed. Please try again.",
                oidc_no_identity: "UMMS did not return your account info. Please contact support.",
                user_not_provisioned: "Your UMMS account is not yet set up in OARS. Please contact support.",
                user_disabled: "Your OARS account is disabled. Please contact support.",
                login_failed: "Sign-in failed. Please try again or contact support.",
            }
            dispatch("showToast", {
                show: true,
                variant: "danger",
                text: errorMessages[oidcError] || "Sign-in failed. Please try again.",
            })
        }
    }, [])
    useEffect(() => {
        if (Object.keys(alertMessage).length > 0) {
            dispatch("showToast", {show: true, variant: alertMessage.alert_type, text: alertMessage.alert_text})
        }
    }, [alertMessage])

    if (error) {
        throw new Error(errorMessage)
    } else {
        return (
            <>
                <VersionCheck />
                <ToastMessage />
                <div className="d-flex flex-column flex-root vh-100">
                    <div className="d-flex flex-column flex-lg-row flex-column-fluid">
                        <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1">
                            <div className="d-flex flex-center flex-column flex-lg-row-fluid">
                                <div className="w-lg-500px p-10">
                                    <div className="d-flex flex-column flex-center">
                                        <OarsLogoBlk
                                            alt="Logo"
                                            className="h-35px d-flex d-lg-none justify-content-center mb-10 theme-light-show"
                                        />
                                    </div>

                                    <div className="text-center mb-10">
                                        <h1 className="text-dark fw-bolder mb-3">Welcome</h1>
                                        <div className="text-gray-600 fw-semibold fs-6">
                                            Your UMMS credentials are required for single sign-on (SSO).
                                        </div>
                                    </div>
                                    <div className="d-grid">
                                        <Button
                                            type="button"
                                            variant="primary"
                                            size="lg"
                                            onClick={() => {
                                                window.location.href = `${window.__APP_CONFIG__?.API_URL || ""}/api/auth/oidc/login`
                                            }}
                                        >
                                            Sign in with UMMS SSO
                                        </Button>
                                    </div>
                                </div>
                                <div className="d-flex flex-stack justify-content-center text-center fs-5 w-100">
                                    <span className="opacity-50">Having trouble logging in?</span>
                                    <a className="ms-2" href="mailto:umms-oars-support@umm.edu">
                                        Contact Support
                                    </a>
                                </div>
                                <div className="d-flex flex-column flex-center d-lg-none">
                                    <IHarborLogoBlack
                                        alt="Logo"
                                        className="h-60px  d-flex d-lg-none justify-content-center  mt-15 mb-5 theme-light-show"
                                    />
                                    <div className="text-dark fs-7 text-center">
                                        An iHarbor product from the University of Maryland Medical System
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className="d-flex flex-lg-row-fluid w-lg-50 gallion-gradient"
                            style={{
                                backgroundImage: `url(${background})`,
                                backgroundPosition: "center",
                                backgroundSize: "cover",
                            }}
                        >
                            <div className="d-flex flex-column flex-center py-7 py-lg-15 py-md-7 px-5 px-md-15 w-100 d-none d-lg-flex">
                                <OarsLogo className="h-80px h-lg-30px w-100 mb-0 mb-lg-5 d-none d-lg-block" />
                                <h1 className="d-none d-lg-block text-white fs-2 fw-bolder text-center mb-7">
                                    Orientation Assessment Reporting System
                                </h1>
                                <IHarborLogoWhite className="h-lg-75px d-none d-lg-block mt-10 mb-5" />
                                <div className="d-none d-lg-block text-white fs-7 text-center">
                                    An iHarbor product from the University of Maryland Medical System
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default Login
